import React from "react";
import { Chip } from "@mui/material";
import { PETICION_ESTADO } from "../../constants";
import { BADGE_COLORS, getBadgeStyles } from "./badgeColors";

/**
 * Badge de estado de petición con colores corporativos
 * NO_ATENDIDO: Rojo (requiere atención)
 * EN_PROCESO: Ámbar (en progreso)
 * PREPARADO: Verde (completado)
 */
export default function EstadoBadge({ estado, size = "normal" }) {
    // Tamaños: normal (desktop) o small (mobile)
    const isSmall = size === "small";
    const height = isSmall ? 20 : 24;
    const fontSize = isSmall ? 10 : 11;

    // Mapeo de estados a colores
    const colorMap = {
        [PETICION_ESTADO.NO_ATENDIDO.value]: BADGE_COLORS.RED,
        [PETICION_ESTADO.EN_PROCESO.value]: BADGE_COLORS.AMBER,
        [PETICION_ESTADO.PREPARADO.value]: BADGE_COLORS.GREEN,
    };

    const color = colorMap[estado] || BADGE_COLORS.GRAY;
    const label = PETICION_ESTADO[estado]?.label || estado;

    return (
        <Chip
            label={label}
            size="small"
            sx={getBadgeStyles(color, { height, fontSize })}
        />
    );
}
